import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { gsap } from 'gsap';
import './splash.css';
import Button from '../components/button';
import girl from '../assets/girl.gif';

const Splash = () => {
  const navigate = useNavigate();
  const [showSplash, setShowSplash] = useState(false);

  const startGame = () => {
    window.dispatchEvent(new Event('play_music'));
    navigate('/intro');
  };

  useEffect(() => {
    const timer = window.setTimeout(() => setShowSplash(true), 2800);

    return () => window.clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (!showSplash) {
      return;
    }

    const timeline = gsap.timeline()
      .fromTo('.splash_main', { 
        opacity: 0, 
        scale: 1.08 }, { opacity: 1, 
        scale: 1, 
        duration: 0.9, 
        ease: 'power2.out'
       })

      .fromTo('.splash_girl', { 
        opacity: 0, 
        x: -90, 
        y: 35, 
        scale: 0.9 
      }, { 
        opacity: 1, 
        x: 0, 
        y: 0, 
        scale: 1, 
        duration: 1, 
        ease: 'back.out(1.4)' }, '-=0.35')
        
      .fromTo('.splash_button', {     opacity: 0, 
        y: 70, 
        scale: 0.82 }, { opacity: 1, 
        y: 0, 
        scale: 1, 
        duration: 0.75, 
        ease: 'elastic.out(1, 0.6)' }, '-=0.25');

    return () => timeline.kill();
  }, [showSplash]);

  return (  
    <div className={`splash ${showSplash ? 'splash_active' : ''}`}>
      <div className="splash_main">
        <img className="splash_girl" src={girl} alt="" />
        <Button className="splash_button" onclick={startGame}>
          Start
        </Button>
      </div>

      <div className="splash_intro">
        <h1 className="splash_title">
          <span>Temple</span>
          <span>Of</span>
          Heka
        </h1>
      </div>
    </div>
  );
}
 
export default Splash;
